import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./adminPage.css";
import { getAllUsers, updateProfileStatus } from "../../../services/authAPI";
import ProfileDetailsModal from "../matrimonyList/profileDetailsModal.tsx";
import { getAllContactMessages } from "../../../services/contactService.js";
import ContactMessagesModal from "./contactMessagesModal.tsx";

const AdminPage = () => {
  const authUser = useSelector((state: any) => state.auth.user);

  const isAdmin = authUser?.email === "svenugoban1996@gmail.com";
  const [refresh, setRefresh] = useState(false);
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState<any>(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [contactMessages, setContactMessages] = useState([]);
  const [contactLoading, setContactLoading] = useState(false);
  const ITEMS_PER_PAGE = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const handleOpenContactMessages = async () => {
    try {
      setContactModalOpen(true);
      setContactLoading(true);

      const response = await getAllContactMessages();

      setContactMessages(response.data || []);
    } catch (error) {
      console.error(error);
      showToast("Failed to load contact messages", "error");
    } finally {
      setContactLoading(false);
    }
  };
  const calculateAgeNum = (dob?: string): number => {
    if (!dob) return 0;
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age--;

    return age;
  };

  const calculateAge = (dob?: string): string | number => (!dob ? "-" : calculateAgeNum(dob));

  const getInitial = (name?: string) => (name ? name.charAt(0).toUpperCase() : "?");

  // ✅ toast state
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  // ✅ show toast helper
  const showToast = (message: string, type: "success" | "error" = "success") => {
    setToast({
      show: true,
      message,
      type,
    });

    setTimeout(() => {
      setToast({
        show: false,
        message: "",
        type: "success",
      });
    }, 3000);
  };

  const handleCloseProfile = () => {
    setOpenModal(false);
    setSelectedProfile(null);
  };

  useEffect(() => {
    if (isAdmin) {
      loadUsers();
    } else {
      setLoading(false);
    }
  }, [isAdmin, refresh]);

  const loadUsers = async () => {
    try {
      setLoading(true);

      const data = await getAllUsers();

      setUsers(data.users || []);
      setCurrentPage(1);
    } catch (err) {
      console.error("Failed to load users", err);

      showToast("Failed to load users", "error");
    } finally {
      setLoading(false);
    }
  };

  // ✅ activate profile
  const handleActivate = async (id: number) => {
    try {
      const res = await updateProfileStatus(id, "active");

      // ✅ remove activated user instantly
      setUsers((prev) => prev.filter((u) => u.id !== id));
      setRefresh((prev) => !prev);

      showToast(res.message || "Profile activated successfully", "success");
    } catch (err: any) {
      showToast(err.message || "Failed to activate profile", "error");
    }
  };

  const handleInActivate = async (id: number) => {
    try {
      const res = await updateProfileStatus(id, "inactive");

      // ✅ remove deactivated user instantly
      setUsers((prev) => prev.filter((u) => u.id !== id));
      setRefresh((prev) => !prev);

      showToast(res.message || "Profile deactivated successfully", "success");
    } catch (err: any) {
      showToast(err.message || "Failed to deactivate profile", "error");
    }
  };

  const totalPages = Math.ceil(users.length / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  const paginatedUsers = users.slice(startIndex, endIndex);

  const handleOpenProfile = async (profile: any) => {
    setSelectedProfile(profile);
    setOpenModal(true);
  };

  // ✅ access denied
  if (!isAdmin && !loading) {
    return <div className='admin-denied'>🚫 Access Denied</div>;
  }

  // ✅ loader
  if (loading) {
    return (
      <div className='admin-loader'>
        <div className='sent-request-spinner'></div>
        <p>Loading inactive users...</p>
      </div>
    );
  }

  return (
    <>
      <div className='admin-inactive-wrapper'>
        {/* HEADER */}
        <div className='admin-title'>
          <div>
            <h2>All Profiles</h2>
          </div>

          <button className='contact-message-btn' onClick={handleOpenContactMessages}>
            Contact Messages
          </button>
        </div>

        {/* EMPTY */}
        {users.length === 0 ? (
          <div className='admin-empty'>
            <h3>No users found</h3>
          </div>
        ) : (
          <div className='admin-grid'>
            {paginatedUsers.map((u) => (
              <div className='admin-card' key={u.id}>
                {/* HEADER */}
                <div className='card-header'>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <img src={u.photo_url || "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt='profile' />

                    <div>
                      <h3>{u.name}</h3>
                      <p>ID: {u.id}</p>
                    </div>
                  </div>

                  <span className={`status ${u.profile_status}`}>{u.profile_status}</span>
                </div>

                {/* DETAILS */}
                <div className='card-body'>
                  <div className='row'>
                    <span>Gender</span>
                    <p>{u.gender || "-"}</p>
                  </div>

                  <div className='row'>
                    <span>Age</span>
                    <p>{calculateAge(u.dob)}</p>
                  </div>

                  <div className='row'>
                    <span>Country</span>
                    <p>{u.resident_country || "-"}</p>
                  </div>

                  <div className='row'>
                    <span>Religion</span>
                    <p>{u.religion || "-"}</p>
                  </div>

                  <div className='row'>
                    <span>Caste</span>
                    <p>{u.caste || "-"}</p>
                  </div>

                  <div className='row'>
                    <span>Marital Status</span>
                    <p>{u.marital_status || "-"}</p>
                  </div>
                </div>

                {/* ACTIONS */}
                <div className='card-actions'>
                  {u.profile_status === "active" ? (
                    <button className='deactivate-btn' onClick={() => handleInActivate(u.id)}>
                      Deactivate
                    </button>
                  ) : (
                    <button className='approve-btn' onClick={() => handleActivate(u.id)}>
                      Activate
                    </button>
                  )}
                  <button className='view-admin-btn' onClick={() => handleOpenProfile(u)}>
                    View Profile
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        {totalPages > 1 && (
          <div className='pagination'>
            <button className='page-btn' onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
              «
            </button>

            <button className='page-btn' onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
              &lt;
            </button>

            <span className='page-info'>
              Showing {startIndex + 1} - {Math.min(endIndex, users.length)} of {users.length}
            </span>

            <button
              className='page-btn'
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &gt;
            </button>

            <button
              className='page-btn'
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
            >
              »
            </button>
          </div>
        )}
      </div>
      <ProfileDetailsModal
        open={openModal}
        onClose={handleCloseProfile}
        profile={selectedProfile}
        calculateAge={calculateAge}
        getInitial={getInitial}
        isAdminView={true}
      />
      <ContactMessagesModal
        open={contactModalOpen}
        onClose={() => setContactModalOpen(false)}
        messages={contactMessages}
        loading={contactLoading}
      />
    </>
  );
};

export default AdminPage;
